import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { themes } from '../styles/designTokens';
import './ThemeSwitcher.css';

const ThemeSwitcher: React.FC = () => {
  const { theme, setTheme } = useTheme();

  return (
    <div className="theme-switcher">
      <h3 className="theme-switcher-title">🎨 Выберите тему</h3>
      <div className="theme-options">
        {Object.entries(themes).map(([key, themeData]) => (
          <button
            key={key}
            className={`theme-option ${theme === key ? 'active' : ''}`}
            onClick={() => setTheme(key as any)}
            style={{
              background: themeData.colors.gradient,
              border: theme === key ? '3px solid #fff' : '2px solid transparent'
            }}
          >
            <div className="theme-preview">
              <div className="theme-circle" style={{ background: themeData.colors.primary }}></div>
              <div className="theme-circle" style={{ background: themeData.colors.secondary }}></div>
              <div className="theme-circle" style={{ background: themeData.colors.accent }}></div>
            </div>
            <span className="theme-name">{themeData.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeSwitcher;
